import PaymentInstructionLayout from "../layouts/PaymentInstructionLayout";
import { useState } from "react";
import { ChevronDown, ChevronUp, Copy, Check } from "lucide-react";
// import CountDownTimer from "./CountDownTimer";
// import formatCurrency from "../../utils/numberFormatter";
import METHOD_LOGO from "./MethodLogos";

const METHOD_LOGOS = METHOD_LOGO;

export default function PaymentInstructionVA({ 
  amount,
  orderId,
  merchantName,
  expired_at,
  selected_method,
  onCheckStatus,
  virtualAccount,
  bankName,
  bankCode,
}) {
  const [activeSection, setActiveSection] = useState("");
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(virtualAccount);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const instructions = {
    VA_BRI: [
      {
        id: "atm",
        title: "ATM BRI",
        content: [
          "1. Masukkan kartu ATM dan PIN",
          "2. Pilih Menu Transaksi Lainnya",
          "3. Pilih Pembayaran, lalu pilih BRIVA",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi pembayaran",
          "6. Transaksi selesai",
        ],
      },
      {
        id: "internet",
        title: "BRI Internet Banking",
        content: [
          "1. Login ke BRI Internet Banking",
          "2. Pilih menu Pembayaran",
          "3. Pilih BRIVA",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi detail pembayaran",
          "6. Selesaikan transaksi dengan mTOKEN",
        ],
      },
      {
        id: "mobile",
        title: "BRI Mobile Banking",
        content: [
          "1. Buka aplikasi BRImo dan login",
          "2. Pilih menu Pembayaran",
          "3. Pilih BRIVA",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi detail pembayaran",
          "6. Masukkan PIN dan selesaikan transaksi",
        ],
      },
    ],
    VA_DANAMON: [
      {
        id: "atm",
        title: "ATM Danamon",
        content: [
          "1. Masukkan kartu ATM dan PIN",
          "2. Pilih Transaksi Lainnya",
          "3. Pilih Virtual Account",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi pembayaran",
          "6. Transaksi selesai",
        ],
      },
      {
        id: "mobile",
        title: "Danamon Mobile Banking",
        content: [
          "1. Login ke aplikasi Danamon Mobile",
          "2. Pilih menu Pembayaran",
          "3. Pilih Virtual Account",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi dan selesaikan transaksi",
        ],
      },
    ],
    VA_MAYBANK: [
      {
        id: "atm",
        title: "ATM Maybank",
        content: [
          "1. Masukkan kartu ATM dan PIN",
          "2. Pilih Transaksi Lainnya",
          "3. Pilih Pembayaran Virtual Account",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi detail pembayaran",
          "6. Transaksi selesai",
        ],
      },
      {
        id: "internet",
        title: "Maybank Internet Banking",
        content: [
          "1. Login ke Maybank2U",
          "2. Pilih menu Pembayaran",
          "3. Pilih Virtual Account",
          "4. Masukkan nomor Virtual Account",
          "5. Konfirmasi dan selesaikan transaksi",
        ],
      },
    ],
  };

  const sections = instructions[bankCode] || [];

  return (
    <PaymentInstructionLayout
      amount={amount}
      orderId={orderId}
      merchantName={merchantName}
      expiredAt={expired_at}
      selectedMethod={selected_method}
      onCheckStatus={onCheckStatus}
      paymentCredential={
        <div className="mt-4 mb-10 text-center">
          <div className="flex items-center gap-2 justify-center">
            <h3 className="text-xl font-bold">{bankName}</h3>
            <img src={METHOD_LOGOS[bankCode] || "/placeholder.svg"} alt={`${bankName} Logo`} className="h-8 w-8 object-contain" />
          </div>
          <p className="text-gray-600">Complete the payment using the virtual account number below.</p>
          <div className="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg font-mono text-lg flex items-center gap-2">
            <span className="flex-1">{virtualAccount}</span>
            <button onClick={handleCopy} className="text-blue-600 hover:text-blue-700 flex items-center">
              {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
        </div>
      }
      howToPay={
        <div className="space-y-4 mt-6">
          <h3 className="text-xl font-bold">How to Pay</h3>
          <div className="space-y-2">
            {sections.map((section) => (
              <div key={section.id} className="border border-gray-200 rounded-lg overflow-hidden">
                <button className="w-full p-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100" onClick={() => setActiveSection(activeSection === section.id ? "" : section.id)}>
                  <span className="font-medium">{section.title}</span>
                  {activeSection === section.id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
                {activeSection === section.id && (
                  <div className="p-4 bg-white border-t border-gray-200">
                    <ol className="list-inside space-y-2 text-gray-600">
                      {section.content.map((step, index) => (
                        <li key={index}>{step}</li>
                      ))}
                    </ol>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      }
    />
  );
}